// import axios from 'axios'
// import jsonAdapter from 'axios-jsonp'
import Promise from 'promise'
import jsonp from 'jsonp'

/* グーグルフォームに送るスクリプト */
export default {

    /* 無効な値は除去する */
    htmlSpecialChars: function(array) {
        for (var ch in array) {
            ch = ch.replace(/&/g,"&amp;") ;
            ch = ch.replace(/"/g,"&quot;") ;
            ch = ch.replace(/'/g,"&#039;") ;
            ch = ch.replace(/</g,"&lt;") ;
            ch = ch.replace(/>/g,"&gt;") ;
        }
    },

    /* パラメータのビルド */
    toQueryParameter(obj) {
        var retVal = '';
        for(let key in obj) {
            retVal += key + '=' + obj[key] + '&';
        }
        return retVal.substr(0, retVal.length-1);
    },

    /* 結果を送信する */
    sendResult: async function(formData, answerData, scores, course) {
        this.htmlSpecialChars(formData);
        const json = {
            nickname: formData.nickname,
            improve: formData.improve,
            gender: formData.gender,
            age: formData.age,
            code: formData.code,
            improve: formData.improve,
            answer: JSON.stringify(answerData),
            times: formData.times,
            scores: JSON.stringify(scores),
            /* 配列の総和はreduceによって求めることができる */
            score: scores.reduce((acc, v) => acc + v),
            course: course,
        };
        const param = this.toQueryParameter(json);
        console.log(param);

        const url = 'https://script.google.com/macros/s/AKfycbyf1KYpnq_hYwMdDQ_sRqKQ1mcZW7aeR_DjM59UFO97s3kfrE3D/exec';
        return new Promise((resolve, reject) => {
            jsonp(url, {name: 'cb', param: param}, function (err, data) {
                if (err) {
                    console.error(err.message);
                    reject(err.message);
                } else {
                    console.log(data);
                    resolve(data);
                }
            });
        });

        /*
        const url = 'https://script.google.com/macros/s/AKfycbxuyuQzO018sUAt39Y2PUQ6nucGFWkyt1jKduQY17PjuXiBlUE/exec';
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                adapter: jsonAdapter,
                params: json,
                callbackParamName: 'cb',
            }).then((response) => {
                console.log("結果の送信に成功しました");
                resolve(response.data);
            }).catch(error => {
                console.error("結果の送信に失敗しました");
                reject(error);
            });
        });
        */
    },

    callback: function(id) {
        console.log(id);
    }
}
